class DrinkingOrder extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll(".tab-opener").forEach((button) => {
      return button.addEventListener("click", this.onButtonClick.bind(this));
    });
    this.querySelectorAll(".juice-opener").forEach((button) => {
      return button.addEventListener(
        "click",
        this.onJuiceButtonClick.bind(this)
      );
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    processButtonClick(event, this, ".tab-content", ".tab-opener");
    processDayChange(event, this);
  }

  onJuiceButtonClick(event) {
    event.preventDefault();
    processButtonClick(event, this, ".juice-content", ".juice-opener");
  }
}

function processDayChange(event, that) {
  const targetID = event.target.dataset.target;
  const target = that.querySelector('#'+targetID);
  const elements = target.getElementsByClassName("juice-navigation");
  const navigation = elements[0]?.getElementsByClassName("juice-opener");
  if (navigation && navigation.length > 0) {
    const first = navigation[0];
    processOpeners(navigation);
    first.classList.add("active");
  }

  const tabElements = target.getElementsByClassName("juice-tabs");
  const juices = tabElements[0]?.getElementsByClassName("juice-content");

  if (juices && juices.length > 0) {
    processTabs(juices);
    
  	const firstJuice = juices[0];
    firstJuice.style.display = "block";
  }
}

function processButtonClick(event, that, contentSelector, openerSelector) {
  const tabs = that.querySelectorAll(contentSelector);
  processTabs(tabs);

  const openers = that.querySelectorAll(openerSelector);
  processOpeners(openers);

  const element = event.target;
  const targetID = event.target.dataset.target;
  const target = that.querySelector("#" + targetID);
  precessElements(element, target);
}

function precessElements(element, target) {
  element.classList.add("active");
  target.style.display = "flex";
}

function processOpeners(openers) {
  for (let i = 0; i < openers.length; i++) {
    const opener = openers[i];
    opener.classList.remove("active");
  }
}

function processTabs(tabs) {
  for (let i = 0; i < tabs.length; i++) {
    const tab = tabs[i];
    tab.style.display = "none";
  }
}

customElements.define("drinking-order", DrinkingOrder);
